import React, { useEffect } from 'react';
import { HeroSection } from './components/HeroSection';
import { ServiceCategories } from './components/ServiceCategories';
import { FeaturedExperiences } from './components/FeaturedExperiences';
import { ActiveRequests } from './components/ActiveRequests';
import { BottomNav } from './components/BottomNav';
export function App() {
  useEffect(() => {
    document.title = 'Finesse';
  }, []);
  return <div className="min-h-screen w-full flex justify-center bg-matte-900" data-id="element-0">
      {/* Mobile App Container */}
      <div className="w-full max-w-md relative min-h-screen bg-matte-900 shadow-2xl overflow-hidden flex flex-col" data-id="element-1">
        {/* Ambient Background Glows */}
        <div className="absolute top-0 left-0 w-full h-96 bg-desert-dusk/5 rounded-full blur-3xl -translate-y-1/2 pointer-events-none" data-id="element-2" />
        <div className="absolute bottom-0 right-0 w-full h-96 bg-sea-teal/5 rounded-full blur-3xl translate-y-1/2 pointer-events-none" data-id="element-3" />

        {/* Scrollable Content */}
        <div className="flex-1 overflow-y-auto hide-scrollbar relative z-10" data-id="element-4">
          <HeroSection data-id="element-5" />
          <ServiceCategories data-id="element-6" />
          <FeaturedExperiences data-id="element-7" />
          <ActiveRequests data-id="element-8" />
        </div>

        {/* Fixed Bottom Navigation */}
        <BottomNav data-id="element-9" />
      </div>
    </div>;
}